<template lang="pug">
.report 
  WebTemplate(
    pagetitle= "展示广告",
    tip= "展示广告报告为您提供展示广告的推广及效果数据，通过对推广账户内各层级数据深入分析，帮助您更及时精准地优化展示广告推广策略（目前只支持原聚合分析用户使用）",
    timeType="7a",
    :currentTab= "currentTab",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :customColumns="customColumns",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sum= "sum",
    :order= "order",
    :legend= "legend", 
    :yAxis= "yAxis",
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    @indiceChange= "indiceChange",
    @tableUpdate= "getTableData",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")
    span.floatr(v-if="dianjingIDList.length > 0" slot="accountSelect")
      label 账号切换：
      v-select(
        v-model="dianjingID",
        :options="dianjingIDList",
        @input="resetCompared")
    i.mv-tips(v-show="mvDemain" slot="tableTitleTip") 为什么看不到流量及转化数据
        v-tooltip(
          :tip="'由于您网站添加的代码为聚合分析代码，无法获取搜索推广对应的流量数据，若您想查看该部分数据，建议为您的网站重新添加360分析代码。'",
          pos="right")
          i.fa.fa-question-circle
    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            :pagetitle="tableTabTitle",
            subtitle="",
            v-if="total > 0",
            style="float: right;")
          CustomIndice(
            :defaults="defaultCustomIndices",
            :hasSystemIndice="true",
            :hasSpreadIndice="true",
            :fluxExtend= "fluxExtend",
            @change="onCustomIndiceChange")
        div(slot="common") 
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
            Search(
              v-show="currentTab != 'product'",
              :placeholder="placeHolder",
              @doSearch="doSearch",
              :defaultValue="keyword")
            v-select(
              v-if="currentTab != 'product' && currentTab != 'planId'",
              v-model="planselected",
              @input="planChange",
              :options="planlistOptions")
            v-select(
              v-if="planselected && currentTab == 'advert__plan__groupName'",
              v-model="groupselected",
              @input="groupChange",
              :options="grouplistOptions")
</template>

<script>
  /* global _ */
  import Store from '../../store/store.js'
  import Mixin from '../mixin.js'
  import WebTemplate from './template'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    store: Store,
    components: {
      WebTemplate
    },
    mixins: [Mixin],
    data () {
      return {
        chartResList: [],
        hasCheckBox: false,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        currentTab: 'product',
        isasc: 0,
        order: 'date',
        legend: [],
        yAxis: [],
        mvDemain: false,
        tablist: [
          {
            id: 'product',
            name: '推广趋势',
            order: 'date',
            reportTableApi: '/api/report/MVadProduct?groupby=date,product',
            basicSummaryStatApi: '/api/report/MVadProduct?groupby=product&issum=1',
            reportLineChartApi: '/api/report/MVadProduct?groupby=date,product'
          },
          {
            id: 'planId',
            name: '推广计划',
            order: 'adpv',
            reportTableApi: '/api/report/MVadPlan?groupby=plan',
            basicSummaryStatApi: '/api/report/MVadPlan?groupby=plan&issum=1',
            reportLineChartApi: '/api/report/MVadPlan?groupby=plan,date'
          },
          {
            id: 'groupName__plan',
            name: '推广组',
            order: 'adpv',
            reportTableApi: '/api/report/MVadGroup?groupby=group',
            basicSummaryStatApi: '/api/report/MVadGroup?groupby=group&issum=1',
            reportLineChartApi: '/api/report/MVadGroup?groupby=group,date'
          },
          {
            id: 'advert__plan__groupName',
            name: '创意',
            order: 'adpv',
            reportTableApi: '/api/report/MVadAdvert?groupby=advert',
            basicSummaryStatApi: '/api/report/MVadAdvert?groupby=advert&issum=1',
            reportLineChartApi: '/api/report/MVadAdvert?groupby=advert,date'
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        customIndice: 'adpv',
        twoIndice: '',
        twoIndiceShow: true,
        sum: {},
        keyword: '',
        tableDataList: [],
        fluxExtend: {'reachrate': '到达率'},
        defaultCustomIndices: ['adpv', 'adclick', 'adctr', 'adcost', 'adcpc', 'adcpm', 'pv', 'vnum', 'reachrate', 'atime', 'tnum'],
        dianjingID: 0,
        dianjingIDList: [],
        planlistOptions: [{value: 0, label: '全部推广计划'}],
        groupselected: 0,
        grouplistOptions: [{value: 0, label: '全部推广组'}],
        planselected: 0
      }
    },
    computed: {
      ...mapState('web', {
        tableIndices: state => state.tableIndices,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      ...mapGetters('web', [
        'indicesMenu',
        'domainId',
        'uiError',
        'fetchLineChartabled',
        'twoIndiceSelectabled'
      ]),
      placeHolder () {
        return `请输入${_.find(this.tablist, {id: this.currentTab}).name}`
      },
      tableTabTitle () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          pvtype: 0,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          djid: this.dianjingID,
          mdim: this.currentTab
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if (this.groupselected) {
          query = _.assignIn({groupId: this.groupselected}, query)
        }
        if (this.planselected) {
          query = _.assignIn({planId: this.planselected}, query)
        }
        if (this.keyword) {
          const keyword = {}
          switch (this.currentTab) {
            case 'planId':
              keyword.plan = this.keyword
              break
            case 'groupName__plan':
              keyword.group = this.keyword
              break
            case 'advert__plan__groupName':
              keyword.advert = this.keyword
              break
          }
          query = _.assignIn({}, keyword, query)
        }
        return query
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      },
      customColumns () {
        const columns = [
          {
            title: '分析维度',
            fixed: true,
            children: [
              {
                title: '推广趋势',
                key: 'name',
                width: 300,
                render: (index, value, item, type) => {
                  if (type === 'date') {
                    return value.split(' ')[0]
                  }
                  return this.textEllipsidRender(index, value, item)
                }
              }
            ]
          }
        ]
        const customColumns = this.getCustomColumns({hasSpread: true})

        if (this.currentTab === 'advert__plan__groupName') {
          columns[0].children = _.concat(columns[0].children, [
            {
              title: '推广计划',
              key: 'plan',
              render: this.textEllipsidRender
            }, {
              title: '推广组',
              key: 'groupName',
              render: this.textEllipsidRender
            }
          ])
        }
        if (this.currentTab === 'groupName__plan') {
          columns[0].children = _.concat(columns[0].children, [
            {
              title: '推广计划',
              key: 'plan',
              render: this.textEllipsidRender
            }
          ])
        }
        columns[0].children[0].title = _.find(this.tablist, {id: this.currentTab}).name
        /* eslint-disable no-nested-ternary */
        columns[0].children[0].key = this.currentTab === 'product' && !this.compared
          ? 'date' : this.currentTab === 'groupName__plan' ? this.compared
            ? 'multiname' : 'groupName' : this.currentTab === 'advert__plan__groupName'
            ? this.compared ? 'multiname' : 'advert' : 'name'
        const newColumns = this.getRecombineColumns(customColumns, this.tableIndices)
        return _.concat(columns, newColumns)
      }
    },
    watch: {
      domainId () {
        this.clearKeyword()
        this.getSiteDianjingIDs()
        this.getTableData()
        this.checkDomainType()
        this.getPlanList()
      },
      compared: function (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        if (this.uiError.errMsg) {
          this.$Modal.warn(this.uiError.errMsg)
        }
      }
    },
    created () {
      this.getSiteDianjingIDs()
      this.checkDomainType()
      this.setTableIndices(this.defaultCustomIndices)
    },
    mounted () {
      this.getPlanList()
    },
    methods: {
      ...mapActions('web', {
        setTableIndices: 'SET_TABLE_INDICES'
      }),
      doSearch (keyword) {
        this.keyword = keyword
        this.getTableData()
      },
      onCustomIndiceChange (indices) {
        this.setTableIndices(indices)
      },
      planChange () {
        this.keyword = ''
        this.getGroupList()
      },
      groupChange () {
        this.keyword = ''
        this.getTableData()
      },
      // 重置compared并获取数据
      resetCompared () {
        this.clearKeyword()
        this.compared = false
        this.chartResList = []
        this.getTableData()
        this.getPlanList()
      },
      getPlanList () {
        const planPromise = this.$http.get('/api/mvad/planlist', {
          params: _.assignIn({}, _.pick(this.query,
            ['cycle', 'domainId', 'start', 'end', 'timespan']))
        })
        let planlist = []
        this.$store.dispatch('VUE_HTTP', [planPromise])
          .then((res) => {
            if (res) {
              planlist = _.concat([{id: 0, name: '全部推广计划'}], res.list)
              this.planlistOptions = _.uniqBy(planlist, 'id').map(item => {
                return {
                  value: item.id,
                  label: item.name
                }
              })
            }
          })
      },
      getGroupList () {
        this.keyword = ''
        this.groupselected = 0
        this.getTableData()
        let grouplist = []
        const grouplistPromise = this.$http.get('/api/mvad/grouplist', {params: this.query})
        this.$store.dispatch('VUE_HTTP', [ grouplistPromise ])
          .then((res) => {
            if (res) {
              grouplist = _.concat([{id: 0, name: '全部推广组'}], res.list)
              this.grouplistOptions = _.uniqBy(grouplist, 'id').map(item => {
                return {
                  value: item.id,
                  label: item.name
                }
              })
            }
          })
      },
      updateTab (tab) {
        if (this.currentTab === tab) return
        this.resetTab(tab)
        this.keyword = ''
        this.planselected = 0
        this.groupselected = 0
        this.resetIndice()
        if (this.currentTab === 'product') {
          this.hasCheckBox = false
        } else {
          this.hasCheckBox = true
        }
        this.getTableData()
      }
    }
  }
</script>
<style scoped>
.search {
  float: right;
}
.right-tab a {
  float: left;
}
.mv-tips {
  color: #999;
  font-size: 12px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// addisplay.vue?92a55264